import { useSelector, useDispatch } from "react-redux";
import { CartoLayer, colorBins } from "@deck.gl/carto";
import { selectSourceById, updateLayer, addFilter } from "@carto/react-redux";
import { useCartoLayerProps } from "@carto/react-api";
import htmlForFeature from "utils/htmlForFeature";
import { setVisitorsOrigin, setBreaks } from "store/appSlice";
import { LEGEND_TYPES } from "@carto/react-ui";
import { _FilterTypes as FilterTypes } from "@carto/react-core";
import { VISITORS_DESTINATION_LAYER_ID } from "components/layers/VisitorsDestinationLayer";
import visitorsDestinationSource from "data/sources/visitorsDestinationSource";
import { getMinMaxQuantiles } from "data/models/model";
import { VISUALS } from "data/config.js";

export const VISITORS_LAYER_ID = "visitorsLayer";

export default function VisitorsLayer() {
  const credentials = useSelector((state) => state.carto.credentials);
  const { visitorsLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, visitorsLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });
  const dispatch = useDispatch();
  const day = useSelector((state) => state.app.day);
  const window = useSelector((state) => state.app.window);
  const breaks = useSelector((state) => state.app.breaks);
  const visitorsOrigin = useSelector((state) => state.app.visitorsOrigin);
  const BUCKETS = VISUALS.buckets;

  if (visitorsLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: VISITORS_LAYER_ID,
      getFillColor: colorBins({
        attr: VISUALS.attr,
        domain: breaks,
        colors: VISUALS.primary_palette,
      }),
      getLineWidth: 0,
      visible: visitorsLayer.visible,
      pickable: true,
      opacity: 0.5,
      autoHighlight: true,
      highlightColor: [71, 219, 153],
      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: [VISUALS.attr],
              formatter: {
                type: "number",
                columns: [VISUALS.attr],
              },
            }),
            style: {},
          };
        }
      },
      onClick: (info) => {
        if (info && info.object) {
          dispatch(setVisitorsOrigin(info.object.properties.geo_id));
          dispatch(
            updateLayer({
              id: VISITORS_DESTINATION_LAYER_ID,
              layerAttributes: {
                visible: true,
              },
            })
          );
          dispatch(
            addFilter({
              id: visitorsDestinationSource.id,
              column: "geo_id",
              type: FilterTypes.IN,
              values: info.object.properties.geo_id,
              owner: "visitorsView",
            })
          );
          dispatch(
            updateLayer({
              id: VISITORS_LAYER_ID,
              layerAttributes: { visible: false },
            })
          );

          // var layerConfig = {
          //   title: "Number of visitors",
          //   switchable: false,
          //   legend: {
          //     attr: VISUALS.attr,
          //     type: LEGEND_TYPES.BINS,
          //     labels: getBreaks(
          //       dataOrigins,
          //       day,
          //       window,
          //       info.object.properties.geo_id
          //     ),
          //     colors: VISUALS.secondary_palette,
          //     collapsible: false,
          //   },
          // };
          // dispatch(
          //   updateLayer({
          //     id: VISITORS_LAYER_ID,
          //     layerAttributes: {
          //       ...layerConfig,
          //     },
          //   })
          // );
        }
      },
      onDataLoad: (data) => {
        if (!visitorsOrigin) {
          getMinMaxQuantiles({
            credentials,
            day_of_week: day,
            part_of_day: window,
            geoid: visitorsOrigin,
            buckets: BUCKETS,
          }).then((results) => {
            dispatch(setBreaks(results[0].quantiles.slice(1)));
            var layerConfig = {
              title: "Number of visitors",
              // changing visible to true will make it show up on the map by default
              visible: true,
              switchable: false,
              legend: {
                attr: VISUALS.attr,
                type: LEGEND_TYPES.BINS,
                labels: results[0].quantiles.slice(1, -1),
                colors: VISUALS.primary_palette,
                collapsible: false,
              },
            };
            dispatch(
              updateLayer({
                id: VISITORS_LAYER_ID,
                layerAttributes: {
                  ...layerConfig,
                },
              })
            );
            cartoLayerProps.onDataLoad(data);
          });
        }
      },

      updateTriggers: {
        getFillColor: [breaks],
        ...cartoLayerProps.updateTriggers,
      },
    });
  }
}
